export default __webpack_public_path__ + "static/media/sub-topic-model-06.619ac067.glb";